import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { useParams } from "react-router-dom";
import { PTPDetailsView } from "./PTPDetailView";

function PTPDetails() {
  const { ptp_id } = useParams<AppPageParams>();
  return <PTPDetailsView id={ptp_id} open={Boolean(ptp_id)} />;
}

export { PTPDetails };
